// German number format: '.' groups thousands, ',' is the decimal separator,
// and the sign is preserved (e.g. -1234.5 -> "-1.234,5"). Precision is capped
// at cents so rounding is intentional rather than relying on the default of 3;
// integers (the usual input) still render without a fractional part.
const moneyFormatter = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 });

export function useFormatting() {
    return {
        formatMoney: (amount: number) => moneyFormatter.format(amount),
    };
}
